import { ValidationDialogState, ValidationDialogOpenState, validationDialogState } from './store/State'
import {
  setIsDialogOpen,
  setIsInitiativeAlertOpen,
  setValidationOptions,
  ValidationDialogActions,
  reset
} from './store/Actions'
import ServiceProviderBase from 'lib/ServiceProviderBase'
import validationDialogReducer from './store/Reducer'
import { IValidationUserResponses } from 'types/UserResponses'

class ValidationService extends ServiceProviderBase<ValidationDialogState, ValidationDialogActions> {
  constructor() {
    super(validationDialogState)
  }

  reduce(state: ValidationDialogState, action: ValidationDialogActions): ValidationDialogState {
    return validationDialogReducer(state, action)
  }

  reset() {
    this.dispatch(reset())
  }

  setIsDialogOpen(isOpenState: ValidationDialogOpenState) {
    this.dispatch(setIsDialogOpen(isOpenState))
  }

  setIsInitiativeAlertOpen(isOpenState: ValidationDialogOpenState) {
    this.dispatch(setIsInitiativeAlertOpen(isOpenState))
  }

  setValidationOptions(validation: IValidationUserResponses) {
    this.dispatch(setValidationOptions(validation))
  }
}

let instance: ValidationService = null

export default (() => {
  if (!instance) {
    instance = new ValidationService()
  }
  return instance
})()
